import React from 'react'
import Grid from '@mui/material/Grid2';
import { Avatar, Box, Button, Typography, Container } from '@mui/material';
import { Cancel, FbIcon, LinkdinIcon, MsgIcon, OfficeIcon, PasswordIcon, PhoneIcon, SecurityIcon } from '../../../assets/icons';
import { YouTubeIcon, WomenEmotions, menAvatar } from '../../../assets/images';


const Overview = () => {
    return (
        <>
            <Container sx={{ maxWidth: "1200px", px: "0 !Important" }}>
                <Box sx={{
                    mt: {
                        xs: '24px',
                        sm: '16px',
                        md: '24px',
                        lg: '40px',
                    },
                }}>
                    <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                            <Box
                                sx={{
                                    border: '1px solid #E8EAF0',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    padding: {
                                        xs: '24px',
                                        sm: '14px',
                                        md: '29px',
                                    },
                                    marginTop: {
                                        xs: '25px',
                                        sm: '0px',

                                    },
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    width: '100%',
                                    boxShadow: '0px 4px 12px 0px #2B2B300F',
                                    height: '100%',
                                }}
                            >
                                <Box display="flex" alignItems="center" mb="30px">
                                <Avatar
                                    alt="Ryan Lee"
                                    src={menAvatar}
                                    sx={{
                                        height: '82px',
                                        width: '82px',
                                        // position: 'absolute',
                                        // top: '-39px',
                                        marginRight:'12px',
                                        border: '3px solid #fff',
                                        backgroundColor: '#E0E0E0',
                                    }}
                                />
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 500, color: '#333', fontSize: '16px' ,mb:'4px'}}>
                                        Ryan Lee
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#666666', fontSize: '16px' }}>
                                        #Ryan Lee21
                                    </Typography>
                                </Box>
                                </Box>
                                <Box marginBottom='12px'>
                                    <Box sx={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                        <MsgIcon></MsgIcon>
                                        <Typography color='#666666' fontSize='16px'>RyanLee092@gmail.com</Typography>

                                    </Box>
                                    <Box sx={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                        <OfficeIcon></OfficeIcon>
                                        <Typography color='#666666' fontSize='16px'>RyanSellSkills</Typography>

                                    </Box>
                                    <Box sx={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                                        <PhoneIcon></PhoneIcon>
                                        <Typography color='#666666' fontSize='16px'>+1 98356152763</Typography>

                                    </Box>

                                </Box>
                                <Button variant='text' size='large' sx={{ textTransform: 'capitalize' }}>Edit Details</Button>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }} display='flex'>
                            <Box sx={{
                                border: '1px solid #E8EAF0',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                position: 'relative',
                                padding: {
                                    xs: '24px',
                                    sm: '14px',
                                    md: '29px',
                                },
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                width: '100%',
                                boxShadow: '0px 4px 12px 0px #2B2B300F',
                            }}>
                                <Box display='flex' alignItems='center' flexDirection='column' marginBottom='12px' className='secuity-icon-wrapper'>
                                    <SecurityIcon></SecurityIcon>
                                    <Typography color='#231F1F' fontWeight='500' fontSize='18px' mb='12px' mt='30px'>Sign in & Security</Typography>
                                    <Typography color='#666666' fontSize='16px' textAlign='center'>Keep your account secure with multiple layers of protection</Typography>
                                </Box>
                                <Button variant='text' size='large' sx={{ textTransform: 'capitalize' }}>View security</Button>

                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }} display='flex'>
                            <Box sx={{
                                border: '1px solid #E8EAF0',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                position: 'relative',
                                width: '100%',
                                padding: {
                                    xs: '24px',
                                    sm: '14px',
                                    md: '29px',
                                },
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                boxShadow: '0px 4px 12px 0px #2B2B300F',
                            }}>
                                <Box display='flex' alignItems='center' flexDirection='column' className='password-icon-wrapper' marginBottom='12px'>
                                    <PasswordIcon></PasswordIcon>
                                    <Typography color='#231F1F' fontWeight='500' fontSize='18px' mb='12px' mt='30px'>Change Password</Typography>
                                    <Typography color='#666666' fontSize='16px' textAlign='center'>Keep your account secure with multiple layers of protection</Typography>
                                </Box>
                                <Button variant='text' size='large' sx={{ textTransform: 'capitalize' }}>View security</Button>

                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                            <Box padding='30px' sx={{
                                border: '1px solid #E8EAF0',
                                padding: {
                                    xs: '24px',
                                    sm: '14px',
                                    md: '29px',
                                },
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                boxShadow: '0px 4px 12px 0px #2B2B300F',
                                height: '100%',
                                width: '100%',
                            }}>
                                <Typography fontWeight='500' fontSize='18px' marginBottom='12px'>Social Media</Typography>
                                <Box display='flex' gap='9px' alignItems='center' borderBottom='1px solid #E8E8EA' paddingBottom='7px' marginBottom='6px'>
                                    <Box sx={{
                                        "& svg": {
                                            minWidth: "24px",
                                        },
                                    }}>
                                        <LinkdinIcon></LinkdinIcon>
                                    </Box>
                                    <Box display='flex' flexDirection='column'>
                                        <Typography fontSize='14px' color='#333333'>Linkedin</Typography>
                                        <Typography fontSize='12px' color='#666666'>www.linkedin.com/company/spook...</Typography>
                                    </Box>

                                </Box>
                                <Box display='flex' gap='9px' alignItems='center' borderBottom='1px solid #E8E8EA' paddingBottom='7px' marginBottom='6px'>
                                    <Box sx={{
                                        "& svg": {
                                            minWidth: "24px",
                                        },
                                    }}>
                                        <FbIcon></FbIcon>
                                    </Box>
                                    <Box display='flex' flexDirection='column'>
                                        <Typography fontSize='14px' color='#333333'>FaceBook</Typography>
                                        <Typography fontSize='12px' color='#666666'>www.linkedin.com/company/spook...</Typography>
                                    </Box>

                                </Box>
                                <Box display='flex' gap='9px' alignItems='center' borderBottom='1px solid #E8E8EA' paddingBottom='7px' marginBottom='6px'>
                                    <Box sx={{
                                        "& img": {
                                            minWidth: "24px",
                                        },
                                    }}>
                                        <img src={YouTubeIcon} alt="you-tube-icon" />
                                    </Box>
                                    <Box display='flex' flexDirection='column'>
                                        <Typography fontSize='14px' color='#333333'>Youtube</Typography>
                                        <Typography fontSize='12px' color='#666666'>www.linkedin.com/company/spook...</Typography>
                                    </Box>
                                </Box>
                                <Box display='flex' gap='9px' alignItems='center' borderBottom='1px solid #E8E8EA' paddingBottom='7px' marginBottom='6px'>
                                    <Box sx={{
                                        "& svg": {
                                            minWidth: "24px",
                                        },
                                    }}>
                                        <Cancel></Cancel>
                                    </Box>
                                    <Box display='flex' flexDirection='column'>
                                        <Typography fontSize='14px' color='#333333'>X</Typography>
                                        <Typography fontSize='12px' color='#666666'>www.linkedin.com/company/spook..</Typography>
                                    </Box>
                                </Box>
                            </Box>

                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
                            <Box className="overview-section-bg" sx={{
                                borderRadius: "8px",
                                padding: "41px 50px 56px",
                                display: "flex",
                                position: "relative",
                                overflow: "hidden",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                color: "#000",
                                fontSize: "16px",
                                fontWeight: 500,
                                height: '100%',
                                marginTop: {
                                    sm: '20px',
                                    md: '0px',
                                },

                            }}>
                                <Box zIndex='1'>
                                    <Typography fontWeight='700' maxWidth='440px' fontSize='calc(22px + 10 * (100vw - 400px) / 1600)' color='#FFFFFF' mb='16px'>Not sure which EasyWebinar plan to go for?</Typography>
                                    <Typography fontSize='16px' color='#FFFFFF' marginBottom='15px'>Our support team has got you covered, 24x7.</Typography>

                                    <Box sx={{
                                        background: "#FFF",
                                        height: "48px",
                                        color: "#000",
                                        borderRadius: "8px",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        lineHeight: "48px",
                                        textAlign: "center",
                                        display: "inline-block",
                                        padding: "0 25px",
                                        marginTop: "15px",
                                        border: "1px solid rgba(0, 0, 0, 0.4)",
                                    }}><a href='' style={{ textDecoration: 'none', color: '#000000' }}>Speak to us</a></Box>

                                </Box>
                                <Box position='absolute' bottom='-9px' right='0'>
                                    <img src={WomenEmotions} alt="female-emotions" style={{ maxWidth: '100%', height: 'auto', maxHeight: '212px' }} />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </>
    )
}

export default Overview
